import { Component, OnInit } from '@angular/core';
import { LayoutState } from 'app/shared/layout/layout-state';
import { ResourceService } from 'app/shared/resources/resource.service';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'app/shared/breadcrumb/breadcrumb.service';
import { MenuService } from 'app/menu/menu.service';
import { filter, skip, tap } from 'rxjs/operators';
import { SbEvent } from 'app/shared/sb-event.emitter';
import { combineLatest } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { QuoteService } from 'app/shared/quote/quote.service';
import { FeatureFlagsService } from 'app/shared/feature-flags.service';
import { EnvironmentService } from 'app/environment.service';
import { LoggingService } from 'app/shared/logging.service';
declare function __renderDone()

//Rendering engine provides a __renderDone function that signales that rendering is complete.
//This just allows to call it in a browser
if (!window['__renderDone']) window['__renderDone'] = () => { }

@Component({
    selector: 'sbw-scraping',
    templateUrl: './scraping.component.html',
    styleUrls: ['./scraping.component.css']
})
export class ScrapingComponent implements OnInit {
    public mechanism: string
    public amount: number
    public currency: string

    private status = { breadcrumbs: false, quote: false, menu: false, resources: false }

    constructor(private resourceService: ResourceService, layoutState: LayoutState, private route: ActivatedRoute,
        breadcrumbService: BreadcrumbService, menuService: MenuService, sbEvents: SbEvent, private title: Title, quoteService: QuoteService,
        featureFlags: FeatureFlagsService, environmentService: EnvironmentService, private loggingService: LoggingService) {
        combineLatest(breadcrumbService.data.pipe(tap(() => this.status.breadcrumbs = true)),
            quoteService.quoteUpdates.pipe(tap(q => { this.currency = q.currencyCode; this.amount = q.totalPrice; this.status.quote = true })),
            menuService.loaded.pipe(tap(() => this.status.menu = true)),
            sbEvents.resourcesLoaded.pipe(tap(() => this.status.resources = true))).subscribe(_ => {
                __renderDone()
            })
        quoteService.initialize = () => { } // initialize() assign as new value to quoteService.quoteUpdates. We nuke it here to avoid that
        environmentService.overrideSbServiceUrl('https://services.dfds.com') //remove this when/if we can access non-prod webfacade from outside
        layoutState.setIsContentLoaded(true, 0)
        featureFlags.disable()
        const { apiKey, wait } = route.snapshot.queryParams
        if (apiKey) {
            menuService.setApiKey(apiKey)
            breadcrumbService.setApiKey(apiKey)
            quoteService.setApiKey(apiKey)
            loggingService.setApiKey(apiKey)
        }
        if (wait) {
            quoteService.useBlocking(wait)
            menuService.useBlocking(wait)
        }
        setTimeout(() => {
            loggingService.logError({
                message: 'Scraping not done after 26s {breadcrumbs} {menu} {quote} {resources}',
                params: [this.status.breadcrumbs, this.status.menu, this.status.quote, this.status.resources]
            }, null)
                .subscribe(a => console.error('Scraping timed out', a, this.status)) //this will kill the process
        }, 26000)
    }

    ngOnInit() {
        const q = this.route.snapshot.queryParams
        const route = q.route || this.throw('route')
        this.mechanism = q.mechanism || this.throw('mechanism')
        this.resourceService.loadResources(route, null, ['Common', 'Quote', 'Currency', 'Payment'])
        this.resourceService.get('PAYMENT_TITLE', false).pipe(filter(f => !!f)).subscribe(t => this.title.setTitle(t))
    }

    throw(p: string): string {
        throw new Error('missing query parameter: ' + p)
    }

}
